import { render, staticRenderFns } from "./paymentHistory.vue?vue&type=template&id=64c4148f"
import script from "./paymentHistory.vue?vue&type=script&lang=js"
export * from "./paymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports